<div class="h-full w-full overflow-hidden flex flex-col flex-nowrap justify-start items-stretch">
  <df-free-trial-bar></df-free-trial-bar>
  <tui-root class="flex-grow w-full overflow-y-auto overflow-x-hidden relative">
    <router-outlet></router-outlet>
    <router-outlet name="statement"></router-outlet>
    <router-outlet name="pricing"></router-outlet>
  </tui-root>
</div>
